import { ReactElement, PropsWithChildren } from 'react';

import { createCustomContext } from '@beeline/lk-utils';

import styles from './styles.module.scss';

import { Header } from ':components';

export function AuthorizedPageLayout({
  children,
}: PropsWithChildren): ReactElement {
  const disableScroll = (): void => {
    document.body.style.overflow = 'hidden';
  };

  const enableScroll = (): void => {
    document.body.style.overflow = 'unset';
  };

  createCustomContext({
    layout: {
      disableScroll,
      enableScroll,
    },
  });

  return (
    <div className={styles.mainContainer}>
      <div className={styles.innerContainer}>{children}</div>
      <Header />
    </div>
  );
}
